<template>
  <div id="purchase_order_create" class="fleet-form-main">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="page-name">
                <span class="page-title" id="purchaseorderHeader" v-if="$route.params.id > 0">Update Insurance Certificate</span>
                <span class="page-title" id="purchaseorderHeader" v-else>Add Insurance Certificate</span>
                <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="InsCertiList">
                <i class="fp-back"> </i> Back
                </button>
            </div>
            <div class="container-fluid">
                <div class="admin-page-content customer-po">
                    <section class="internal-container border-top-table-fl">
                        <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="InsCertiForm">
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="ins_user_type">Insurance User Type:</label>
                                    <v-select class="close-remove" v-model="ins_user_type" name="ins_user_type" placeholder="Select Insurance User Type"
                                                label="text"
                                                @input="onInsuranceTypeChange($event)"
                                                :options="insUserTypeArr" >
                                    </v-select>
                                    <div class="field-error">{{ins_user_type_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="name">{{ins_user_type.text}} Name:</label>
                                    <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                    <div class="field-error">{{name_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="phone_no">{{ins_user_type.text}} Phone:</label>
                                    <input type="text" class="form-control" v-cleave="{delimiter: '-',blocks: [3, 3, 4]}" v-model="phone_no" id="phone_no" placeholder="999-999-9999" name="phone_no">
                                    <!-- <input-mask id="phone_no" :alwaysShowMask="true" name="phone_no" v-model="phone_no" mask="999-999-9999" class="form-control" type="tel"></input-mask> -->
                                    <div class="field-error">{{phone_no_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="email_id">{{ins_user_type.text}} Email:</label>
                                    <input type="text" class="form-control" v-model="email_id" id="email_id" placeholder="Enter email address" name="email_id">
                                    <div class="field-error">{{email_id_error_msg}}</div>
                                </div>
                            </div>
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require" for="address">{{ins_user_type.text}} Address:</label>
                                    <textarea type="text" class="form-control" v-model="address" id="address" placeholder="Enter Address" name="address"></textarea>
                                    <div class="field-error">{{address_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="city">{{ins_user_type.text}} City:</label>
                                    <input type="text" class="form-control" v-model="city" id="city" placeholder="Enter City" name="city">
                                    <div class="field-error">{{city_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require" for="state">{{ins_user_type.text}} State:</label>
                                    <input type="text" class="form-control" v-model="state" id="state" placeholder="Enter State" name="state">
                                    <div class="field-error">{{state_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label" for="zip_code">{{ins_user_type.text}} Zip Code:</label>
                                    <input type="text" class="form-control" v-model="zip_code" id="zip_code" placeholder="Enter Zip Code" name="zip_code">
                                    <!-- <div class="field-error">{{zip_code_error_msg}}</div> -->
                                </div>
                            </div>
                            <div class="form-row row-cols-md-4 row-cols-1">
                                <div class="col form-group">
                                <label class="control-label" for="vvg_location">VVG Location:</label>
                                <v-select class="close-remove" v-model="vvg_location" name="vvg_location" id="vvg_location" placeholder="Select VVG Location"
                                            label="text"
                                            :options="insLocationArr"
                                            :disabled = "vvg_location_disable">
                                </v-select>
                                </div>
                            </div>
                            <div class="form-row row-cols-md-2 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label" for="period">Document:</label>
                                    <vue-dropzone
                                                id="insuranceDocs"
                                                :options="dropzoneOptions"
                                                :destroyDropzone=false
                                                ref="dropzone"
                                                :headers="dropzoneOptions.headers"
                                                @vdropzone-files-added="manuallyAddFile"
                                                @vdropzone-complete="afterComplete"
                                                @vdropzone-success="storeDocument"
                                                @vdropzone-removed-file="removedSelectedFile"
                                                @vdropzone-upload-progress="dropzoneUploadProgress"
                                    >
                                    </vue-dropzone>
                                    <div class="field-error">{{docerrors}}</div>
                                    <div  v-if="dropZonePreviewFiles != null && dropZonePreviewFiles.length > 0">
                                        <label class="control-label" for="period">Attachments:</label>
                                        <div class="policy-attachment">
                                            <template  v-for="(uFile,fKey) in dropZonePreviewFiles">
                                                <div v-bind:key="'fileDiv'+fKey" class="attachment-list">
                                                    <i v-if="uFile.extension == 'pdf'" class="fp-pdf-icon"></i>
                                                    <i v-if="uFile.extension == 'doc' || uFile.extension == 'docs'" class="fp-text-document"></i>
                                                    <i v-if="uFile.extension == 'jpg' ||  uFile.extension == 'png' ||  uFile.extension == 'jpeg' " class="fp-image"></i>
                                                    <a title='View File' href="javascript:void(0)"  v-on:click="openDocument(uFile.url,uFile.extension)" v-bind:key="'fileName'+fKey" >
                                                        {{ uFile['file_name'] }}
                                                    </a>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;
                                                    <button type="button"  v-bind:key="'cancelBtn'+fKey" v-on:click="removeServerFile(uFile['file_name'],fKey);" class="">
                                                        <i class="fp-close color-red"></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="purchase-order-create-main form-group table-responsive-sm">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col" class="require" style="width:300px;">Type</th>
                                            <th scope="col" class="require">Policy Number</th>
                                            <th scope="col" class="require" >Effective Date</th>
                                            <th scope="col" class="require" >Expiration Date</th>
                                            <th scope="col"> Action </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in rows" :key="index">
                                            <td>
                                                <v-select class="close-remove" v-model="row.ins_type" name="ins_user_type" 
                                                    placeholder="Select Type"
                                                    label="text"
                                                    :options="insCertiPolicyTypeArr">
                                                </v-select>
                                                <input v-if="row.ins_type != undefined && row.ins_type.value === 'other'" type="text" v-model="row.other_ins_type" name="other_ins_type" placeholder="Enter Other Type" class="form-control" style="margin-top:6px;">
                                                <div class="field-error">{{row.ins_type_error_msg}}</div>
                                            </td>
                                            <td>
                                                <input type="text" v-model="row.policy_number" name="policy_number" placeholder="Policy Number" class="form-control">
                                                <div class="field-error">{{row.policy_number_error_msg}}</div>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <date-picker type="text" placeholder="MM/DD/YYYY" v-model="row.policy_eff_date" name="policy_eff_date" id="policy_eff_date" :config="options"></date-picker>
                                                    <label for="policy_eff_date"  class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{row.policy_eff_date_error_msg}}</div>
                                            </td>
                                            <td>
                                                <div class="input-group">
                                                    <date-picker type="text" placeholder="MM/DD/YYYY" v-model="row.policy_exp_date" name="policy_exp_date" id="policy_exp_date" :config="options"></date-picker>
                                                    <label for="policy_exp_date"  class="fp-calendar input-calender-icon"></label>
                                                </div>
                                                <div class="field-error">{{row.policy_exp_date_error_msg}}</div>
                                            </td>
                                            <td class="text-center valign-middle">
                                                <template v-if="rows.length != 1">
                                                    <span class="close-row"> <a href="#" v-on:click="removeElement(index);"> × </a></span>
                                                </template>
                                                <template v-else>
                                                    <span class="close-row"> _ </span>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                    <i class="fp-add"></i> Add Line Item
                                </button>
                            </div>
                            
                            <div class="form-group">
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                            </div>
                            <div class="btn-groups">
                                <button type="submit" :disabled='isDisableStore' v-if="$route.params.id > 0" id="CreateInsCertiBtn" class="btn btn-primary" v-on:click.prevent="CreateInsuranceCertificate">
                                <i class="fp-reload"> </i>  Update
                                </button>
                                <button type="submit" :disabled='isDisableStore' v-else id="CreateInsCertiBtn" class="btn btn-primary" v-on:click.prevent="CreateInsuranceCertificate">
                                <i class="fp-save"> </i>  Save
                                </button>
                                <button type="submit" :disabled='isDisableStore' v-if="$route.params.id == undefined" id="createAndContinueInsCertiBtn" class="btn btn-tertiary" v-on:click.prevent="CreateInsuranceCertificate(flag='Save and Continue')">
                                <i class="fp-save-continue"> </i>  Save and Continue
                                </button>
                                <button type="submit" id="cancelInsCertiBtn" class="btn btn-tertiary" v-on:click.prevent="InsCertiList">
                                <i class="fp-close"> </i>  Cancel
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </template>
        <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
    import Vue from "vue";

    import {commonMixins} from '../mixins/commonMixins';
    import {contractMixins} from '../mixins/contractMixins';
    
    
    import vue2Dropzone from 'vue2-dropzone';
    import moment from 'moment';
    // import InputMask from 'vue-input-mask';
    // Vue.component('input-mask', InputMask);
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    export default {
        name: "InsuranceCertificateCreate",
        metaInfo() {
            return {
                title: (this.$route.params.id > 0)? "Update Insurance Certificate | " +process.env.COPYRIGHT_NAME : "Create Insurance Certificate | " +process.env.COPYRIGHT_NAME
            }
        },
        components: {
            vueDropzone: vue2Dropzone,
        },
        mixins:[commonMixins,contractMixins],
        data: () => ({
            isDisableStore: false,
            isEdit:false,
            permissions: [],
            cantAccessPage: "",
            loading:false,
            showCharges: false,
            chargesArr: [],
            type: "",
            insUserTypeArr:[
                {text:'Customer' , value:'customer'},
                {text:'Vendor',value:'Vendor'}
            ],
            insLocationArr: [],
            // insLocationArr:[
            //     {"text": "Miramar Truck Body & Equipment", "value": "Miramar Truck Body & Equipment"},
            //     {"text": "VTT El Centro", "value": "VTT El Centro"},
            //     {"text": "VTC San Diego", "value": "VTC San Diego"},
            //     {"text": "VTRL San Diego", "value": "VTRL San Diego"},
            //     {"text": "BusWest", "value": "BusWest"},
            //     {"text": "VTC Chandler", "value": "VTC Chandler"},
            //     {"text": "VTC Reno", "value": "VTC Reno"},
            //     {"text": "VTC Kingman", "value": "VTC Kingman"},
            //     {"text": "VTC Las Vegas", "value": "VTC Las Vegas"},
            //     {"text": "VTC Flagstaff", "value": "VTC Flagstaff"},
            //     {"text": "VTT Nogales", "value": "VTT Nogales"},
            //     {"text": "VTC Tucson", "value": "VTC Tucson"},
            //     {"text": "VTC Tolleson", "value": "VTC Tolleson"},
            //     {"text": "VTRL Tolleson", "value": "VTRL Tolleson"},
            //     {"text": "VTC Warsaw", "value": "VTC Warsaw"},
            //     {"text": "VTC New Bern", "value": "VTC New Bern"},
            //     {"text": "VTC Florence", "value": "VTC Florence"},
            //     {"text": "VTC Rocky Mount", "value": "VTC Rocky Mount"},
            //     {"text": "VTC Wilmington", "value": "VTC Wilmington"},
            //     {"text": "VTC Wilmington B Shop", "value": "VTC Wilmington B Shop"},
            //     {"text": "VTC Raleigh", "value": "VTC Raleigh"},
            //     {"text": "VTC Hildebran", "value": "VTC Hildebran"},
            //     {"text": "VTC Ayden", "value": "VTC Ayden"},
            //     {"text": "VTC Hope Mills", "value": "VTC Hope Mills"},
            //     {"text": "VTC Summerville", "value": "VTC Summerville"},
            //     {"text": "Hope Mills Collision Center", "value": "Hope Mills Collision Center"},
            //     {"text": "VTC Greensboro", "value": "VTC Greensboro"},
            //     {"text": "Nashville Collision Center", "value": "Nashville Collision Center"},
            //     {"text": "VTC Madison", "value": "VTC Madison"},
            //     {"text": "VTT Nashville", "value": "VTT Nashville"},
            //     {"text": "Decatur Collision Center", "value": "Decatur Collision Center"},
            //     {"text": "VTC Nashville", "value": "VTC Nashville"},
            //     {"text": "VTC Bowling Green", "value": "VTC Bowling Green"},
            //     {"text": "VTC Kingsport", "value": "VTC Kingsport"},
            //     {"text": "VTC Piedmont", "value": "VTC Piedmont"},
            //     {"text": "VTC Greenville SC", "value": "VTC Greenville SC"},
            //     {"text": "VTC Greenville SC Sales", "value": "VTC Greenville SC Sales"},
            //     {"text": "VTC Asheville", "value": "VTC Asheville"},
            //     {"text": "VTC Lexington", "value": "VTC Lexington"},
            //     {"text": "Crossroads", "value": "Crossroads"},
            //     {"text": "TransWest/BusWest Truck Center", "value": "TransWest/BusWest Truck Center"},
            //     {"text": "Ontario Collision Center", "value": "Ontario Collision Center"},
            //     {"text": "VTRL Fontana", "value": "VTRL Fontana"},
            //     {"text": "SelecTrucks", "value": "SelecTrucks"},
            //     {"text": "VTC Fontana", "value": "VTC Fontana"},
            //     {"text": "VTRL Rancho Dominguez", "value": "VTRL Rancho Dominguez"},
            //     {"text": "VTC South Bay (Carson)", "value": "VTC South Bay (Carson)"},
            //     {"text": "VTRL City of Industry", "value": "VTRL City of Industry"},
            //     {"text": "VTC Whitter", "value": "VTC Whitter"},
            //     {"text": "VTC Ventura (Oxnard)", "value": "VTC Ventura (Oxnard)"},
            //     {"text": "Bulk (VTT Whittier)", "value": "Bulk (VTT Whittier)"},
            //     {"text": "Central California Truck and Trailer Sales", "value": "Central California Truck and Trailer Sales"},
            //     {"text": "VTC Hesperia (HD - High Desert)", "value": "VTC Hesperia (HD - High Desert)"}
            // ],
            ins_user_type: {
                value: "customer" ,
                text:"Customer"
            },
            ins_user_type_error_msg:"",
            name_error_msg:"",
            phone_no_error_msg:"",
            email_id_error_msg:"",
            address_error_msg:"",
            city_error_msg:"",
            state_error_msg:"",
            zip_code_error_msg:"",
            type_error_msg: "",
            amount_error_msg: "",
            insCertiPolicyTypeArr:[
                {text:'GL' , value:'gl'},
                {text:'AL',value:'al'},
                {text:'WC',value:'wc'},
                {text:'Other',value:'other'}
            ],
            options: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            rows: [],
            name:"",
            phone_no: "",
            email_id: "",
            address:"",
            city:"",
            state:"",
            zip_code:"",
            vvg_location:"",
            vvg_location_disable:false,
            componentArr:[],
            dropzoneOptions: {
                url: process.env.ROOT_API +"/insurance-certificate/store-docs",
                method: 'POST',
                maxFilesize: 3.99, //MB
                maxFiles: 5,
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                addRemoveLinks: true,
                acceptedFiles: ".jpg, .jpeg, .png, .doc, .pdf, .docx",
                headers: {
                    'Accept': 'application/json',
                    "Authorization": "Bearer "+localStorage.getItem("tkn"),
                    'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                    "Cache-Control": "no-cache"
                },
                dictRemoveFileConfirmation: "Are you sure?You can\'t revert your action",
                destroyDropzone:false,
            },
            domain:process.env.FOLDER_URL+'/',
            files:[],
            dropZonePreviewFiles:[],
            docerrors:'',
            requiredFlagQty:'require'
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_insurance_certificate') {
                            self.cantAccessPage = true;
                        }
                    }
                }
            },
            chargesArr(){
                var self = this;
                self.blockRemoval = self.chargesArr.length <= 1
            },

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            self.getPermissions();
            var path = window.location.pathname;
            var segments = path.split("/");
            
            this.loadFieldData(['ins_locations']);
            if (segments[3]) {
                //one can not change insurance certificate type while updating...
                self.loadInsuranceCertificate();
                self.loadInsuranceCertificateItems();
            }
            var decodeStr = "";
            if ( this.$route.query.data != '' && this.$route.query.data != undefined ) {
                decodeStr = atob(this.$route.query.data)
            }
            self.rows.push({
                    ins_certi_item_id:0,
                    policy_number:"",
                    policy_number_error_msg:"",
                    policy_eff_date:"",
                    policy_eff_date_error_msg:"",
                    policy_exp_date:"",
                    policy_exp_date_error_msg:"",
                    ins_type:null,
                    other_ins_type:"",
                    ins_type_error_msg:""
            });
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                console.log('userJson',userJson);
                if (userJson.roles.length > 0) {
                    for(var i = 0; i < userJson.roles.length; i++){
                        userJson.roles[i].name = userJson.roles[i].name.toLowerCase();
                        if (userJson.roles[i].name == 'insurance agent') {
                            self.vvg_location_disable = true;
                            if(userJson.location_id != null)
                            {
                                self.vvg_location = {value: userJson.location_id, text: userJson.locationName };
                            }
                        }
                    }
                }
            }
            // Check if the fourth segment is missing in the 'segments' array.
            if (!segments[3]) {
                var index=self.rows.length-1;
                // Only proceed if the user type is 'customer'.
                if(self.ins_user_type.value == 'customer'){
                    // Calculate policy effective and expiry dates for customer insurance.
                    const currentDate = moment();
                    const desiredDate = moment("01/03/" + currentDate.year(), "DD/MM/YYYY");
                    const policyEffMoment = moment(desiredDate, "DD/MM/YYYY");
                    self.currentYear = policyEffMoment.year();
                    self.nextYear = this.currentYear + 1;
                    self.rows[index].policy_eff_date = policyEffMoment.format("DD/MM/YYYY");
                    self.rows[index].policy_exp_date = policyEffMoment.clone().add(1, "year").format("DD/MM/YYYY");
                }
            }
        },
        methods: {
            // This function handles the change event when the insurance type is modified.
            // It updates policy dates based on the selected insurance type.
            onInsuranceTypeChange(event){
                var self = this;
                var index=self.rows.length-1;
                if(event.value == 'customer'){
                    // Calculate policy effective and expiry dates for customer insurance.
                    const currentDate = moment();
                    const desiredDate = moment("01/03/" + currentDate.year(), "DD/MM/YYYY");
                    const policyEffMoment = moment(desiredDate, "DD/MM/YYYY");
                    self.currentYear = policyEffMoment.year();
                    self.nextYear = this.currentYear + 1;
                    self.rows[index].policy_eff_date = policyEffMoment.format("DD/MM/YYYY");
                    self.rows[index].policy_exp_date = policyEffMoment.clone().add(1, "year").format("DD/MM/YYYY");
                }else{
                    // Reset policy dates for other insurance types.
                    self.rows[index].policy_eff_date = '';
                    self.rows[index].policy_exp_date = '';
                }
            },
            onSearchUser(search, loading) {
                var self = this;
                if (search.length > 0) {

                    loading(true);
                    self.searchField(loading, search, 'user', '');
                }
            },
            onSearchModel(search, loading) {
                var self = this;
                if (search.length > 2) {

                    loading(true);
                    self.searchField(loading, search, 'vehicle_model', '');
                }
            },
            onSearchAssetPool(search, loading){
                var self = this;
                if (search.length > 1) {
                    loading(true);
                    self.searchField(loading, search, 'vehicle_pool', '');
                }
            },
            onSearchComponent(search, loading){
                var self = this;
                if (search.length > 1) {
                    loading(true);
                    self.searchField(loading, search, 'component', '');
                }
            },

            addRow: function () {
                var self = this;
                var index=self.rows.length-1;
                self.rows[index].policy_number_error_msg = "";
                self.rows[index].policy_eff_date_error_msg = "";
                self.rows[index].policy_exp_date_error_msg = "";
                self.rows[index].ins_type_error_msg = "";
                if (((self.rows[index].ins_type != null && self.rows[index].ins_type) || ( self.rows[index].policy_number != null && self.rows[index].policy_number != "" )) && self.rows[index].policy_eff_date!="" && self.rows[index].policy_exp_date!="") {

                    self.rows.push({
                        ins_certi_item_id:0,
                        policy_number:"",
                        policy_number_error_msg:"",
                        policy_eff_date:"",
                        policy_eff_date_error_msg:"",
                        policy_exp_date:"",
                        policy_exp_date_error_msg:"",
                        ins_type:null,
                        other_ins_type:"",
                        ins_type_error_msg:""
                    });

                } else {
                    if ( self.rows[index].ins_type == null || self.rows[index].ins_type.value == "" ) {
                        self.rows[index].ins_type_error_msg = "Type is Required.";
                    } else if ( self.rows[index].ins_type.value === 'other' && (self.rows[index].other_ins_type == null || self.rows[index].other_ins_type == "")) {
                        self.rows[index].ins_type_error_msg = "Type is Required.";
                    }
                    if ( self.rows[index].policy_number == null || self.rows[index].policy_number == "" ) {
                        self.rows[index].policy_number_error_msg = "Policy number is Required.";
                    }
                    if (self.rows[index].policy_eff_date == null || self.rows[index].policy_eff_date == "") {
                        self.rows[index].policy_eff_date_error_msg = "Effective Date is Required.";
                    }
                    if (self.rows[index].policy_exp_date == null || self.rows[index].policy_exp_date == "") {
                        self.rows[index].policy_exp_date_error_msg = "Expiration Date is Required.";
                    }
                }

            },
            removeElement: function (index) {
                var self = this;
                if(self.rows.length > 1)
                {
                    if(self.rows[index].ins_certi_item_id==0)
                    {
                        self.rows.splice(index, 1);

                    }else {
                        if (confirm('Are you sure that you want to delete this Insurance Certificate Item? ')) {
                            $.ajax({
                                url: process.env.ROOT_API + "/insurance-certificate/item-delete",
                                type: "POST",
                                data: {'id': self.rows[index].ins_certi_item_id},
                                headers: this.ajxHeaders,
                                dataType: "json",
                                success: function (data) {
                                    if (data.status == "success") {
                                        self.rows.splice(index, 1);
                                    }

                                },
                                error: function (jqXHR, exception) {
                                    self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-certificate-item');
                                },
                            });
                        }
                    }
                }
            },

            InsCertiList() {
                var self = this;
                self.$router.push("/insurance-certificate/list");
            },

            CreateInsuranceCertificate(flag) {
                var self = this;
                var error = false;
                self.ins_user_type_error_msg="";
                self.name_error_msg="";
                self.phone_no_error_msg="";
                self.email_id_error_msg="";
                self.address_error_msg="";
                self.city_error_msg="";
                self.state_error_msg="";
                self.zip_code_error_msg="";
                self.docerrors = "";

                if (!self.ins_user_type || self.ins_user_type == null || self.ins_user_type == "") {
                    self.ins_user_type_error_msg = "Insurance User Type Required.";
                    error = true;
                }
                if (!self.name || self.name == null || self.name == "") {
                    self.name_error_msg = "Name Required.";
                    error = true;
                }

                // if (self.phone_no.trim() == "___-___-____" || self.phone_no.trim() == "") {
                //     self.phone_no_error_msg = "Phone Required.";
                //     error = true;
                // }
                if (self.phone_no.trim() != "" && self.phone_no.trim() != "___-___-____") {
                    var phoneRE = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    if (!self.phone_no.trim().match(phoneRE)) {
                        self.phone_no_error_msg = "Enter Valid Phone No.";
                        error = true;
                    }
                }
                // if (!self.email_id || self.email_id == null || self.email_id == "") {
                //     self.email_id_error_msg = "Email Required.";
                //     error = true;
                // }
                if (self.email_id.includes(',')){
                    var email_id = self.email_id.split(',');
                    if (email_id.length > 0){
                        for( var i=0;i < email_id.length;i++){
                            if (!self.validEmail(email_id[i])){
                                self.email_id_error_msg = 'Please enter valid email';
                                error = true;
                            }
                        }
                    }
                }else{
                    if (self.email_id != '' && !self.validEmail(self.email_id)){
                        self.email_id_error_msg = 'Please enter valid email';
                        error = true;
                    }
                }

                if (!self.address || self.address == null || self.address == "") {
                    self.address_error_msg = "Address Required.";
                    error = true;
                }
                if (!self.city || self.city == null || self.city == "") {
                    self.city_error_msg = "City Required.";
                    error = true;
                }
                if (!self.state || self.state == null || self.state == "") {
                    self.state_error_msg = "State Required.";
                    error = true;
                }
                // if (!self.zip_code || self.zip_code == null || self.zip_code == "") {
                //     self.zip_code_error_msg = "Zip Code Required.";
                //     error = true;
                // }
                

                if (self.files.length > 0) {
                    if(self.files.length > 5){
                        self.docerrors = 'Only Five Files Allowed';
                        error = true;
                        return;
                    }
                }
                for (var i = 0; i < self.rows.length; i++) {
                    self.rows[i].policy_number_error_msg = "";
                    self.rows[i].policy_eff_date_error_msg = "";
                    self.rows[i].policy_exp_date_error_msg = "";
                    self.rows[i].ins_type_error_msg = "";
                    console.log(self.rows[i].ins_type);
                    if ( self.rows[i].ins_type == null || self.rows[i].ins_type.value == "" ) {
                        self.rows[i].ins_type_error_msg = "Type is Required.";
                        error = true;
                    } else if ( self.rows[i].ins_type.value === 'other' && (self.rows[i].other_ins_type == null || self.rows[i].other_ins_type == "")) {
                        self.rows[i].ins_type_error_msg = "Type is Required.";
                        error = true;
                    }
                    if ( self.rows[i].policy_number == null || self.rows[i].policy_number == "" ) {
                        self.rows[i].policy_number_error_msg = "Policy number is Required.";
                        error = true;
                    }
                    if (self.rows[i].policy_eff_date == null || self.rows[i].policy_eff_date == "") {
                        self.rows[i].policy_eff_date_error_msg = "Effective Date is Required.";
                        error = true;
                    }
                    if (self.rows[i].policy_exp_date == null || self.rows[i].policy_exp_date == "") {
                        self.rows[i].policy_exp_date_error_msg = "Expiration Date is Required.";
                        error = true;
                    }
                }

                if (!error) {

                    self.loading = true;
                    var path = window.location.pathname;
                    var segments = path.split("/");

                    if (segments[3])
                    {
                        $("#CreateInsCertiBtn").val("Updating ...");
                        $("#CreateInsCertiBtn").prop("disabled", true);
                        $("#cancelInsCertiBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueInsCertiBtn").val("Saving ...");
                            $("#CreateInsCertiBtn").prop("disabled", true);
                            $("#createAndContinueInsCertiBtn").prop("disabled", true);
                            $("#cancelInsCertiBtn").prop("disabled",true);

                        } else{

                            $("#CreateInsCertiBtn").val("Saving ...");
                            $("#CreateInsCertiBtn").prop("disabled", true);
                            $("#createAndContinueInsCertiBtn").prop("disabled", true);
                            $("#cancelInsCertiBtn").prop("disabled",true);
                        }
                    }

                    var fields = $("#InsCertiForm").serializeArray();
                    // alert(JSON.stringify(fields));

                    if ( self.files.length > 0 ) {
                        fields.push({name: "doc_path", value: JSON.stringify(self.files)});
                    } else {
                        fields.push({name: "doc_path", value: null});
                    }

                    if (!self.rows[0]) {
                       self.rows = [];
                    }
                    fields.push({name: "ins_user_type", value: self.ins_user_type.value});
                    fields.push({name: "vvg_location", value: self.vvg_location.value});
                    fields.push({name: "insuranceCertificateItems", value: JSON.stringify(self.rows)});
                    fields.push({ name: "id", value: segments[3] });
                    $.ajax({
                        url: process.env.ROOT_API + "/insurance-certificate/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {

                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateInsCertiBtn").val("Update");
                                $("#CreateInsCertiBtn").prop("disabled", false);
                                $("#cancelInsCertiBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueInsCertiBtn").val("Save and Continue");
                                    $("#CreateInsCertiBtn").prop("disabled", false);
                                    $("#createAndContinueInsCertiBtn").prop("disabled", false);
                                    $("#cancelInsCertiBtn").prop("disabled",false);

                                } else{

                                    $("#CreateInsCertiBtn").val("Save");
                                    $("#CreateInsCertiBtn").prop("disabled", false);
                                    $("#createAndContinueInsCertiBtn").prop("disabled", false);
                                    $("#cancelInsCertiBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "files" || data.status == "prevent") {

                                self.docerrors = data.message;
                                return;

                            }

                            if (data.status == "success") {
                                self.showCharges = false;
                                if (flag == "Save and Continue") {
                                    self.removeAllFiles();
                                    $("#InsCertiForm").trigger("reset");
                                    self.name="";
                                    self.phone_no="";
                                    self.email_id="";
                                    self.address= "";
                                    self.city= "";
                                    self.state= "";
                                    self.zip_code= "";
                                    self.vvg_location="";
                                    self.rows=[];
                                    self.rows.push({
                                        ins_certi_item_id:0,
                                        policy_number:"",
                                        policy_number_error_msg:"",
                                        policy_eff_date:"",
                                        policy_eff_date_error_msg:"",
                                        policy_exp_date:"",
                                        policy_exp_date_error_msg:"",
                                        ins_type:null,
                                        other_ins_type:"",
                                        ins_type_error_msg:""
                                    });

                                } else{
                                    self.$router.push("/insurance-certificate/list");
                                }

                            } else {

                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (segments[3])
                            {
                                $("#CreateInsCertiBtn").val("Update");
                                $("#CreateInsCertiBtn").prop("disabled", false);
                                $("#cancelInsCertiBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#InsCertiForm").trigger("reset");
                                    $("#createAndContinueInsCertiBtn").val("Save and Continue");
                                    $("#CreateInsCertiBtn").prop("disabled", false);
                                    $("#createAndContinueInsCertiBtn").prop("disabled", false);
                                    $("#cancelInsCertiBtn").prop("disabled",false);

                                } else{

                                    $("#CreateInsCertiBtn").val("Save");
                                    $("#CreateInsCertiBtn").prop("disabled", false);
                                    $("#createAndContinueInsCertiBtn").prop("disabled", false);
                                    $("#cancelInsCertiBtn").prop("disabled",false);

                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,false,'insurance-certificate-create');
                        }
                    });
                }else{
                    self.errorValidationFocus();
                }
            },
            loadInsuranceCertificate() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/insurance-certificate/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.isEdit = true;
                            self.name = data.content.name;
                            self.phone_no = data.content.phone;
                            self.email_id = data.content.email;
                            self.ins_user_type = {value: data.content.ins_user_type, text: self.titleCase(data.content.ins_user_type) };
                            self.address = data.content.address;
                            self.city = data.content.city;
                            self.state = data.content.state;
                            self.zip_code = data.content.zip_code;
                            self.vvg_location = {value: data.content.vvg_location, text: data.content.location_name };
                            self.dropZonePreviewFiles = data.content.doc_path;
                            self.loadFilesPreview();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'get-insurance-certificate-detail');
                    }
                });
            },
            loadInsuranceCertificateItems(){
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/insurance-certificate/items/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);

                        if (data.status == "success") {

                            self.rows = [];
                            if(data.content.length>=1) {
                                for (var i = 0; i < data.content.length; i++) {

                                    if(data.content[i].ins_type == 'gl'){
                                        data.content[i].ins_type_txt = 'GL';   
                                    } else if(data.content[i].ins_type == 'al'){
                                        data.content[i].ins_type_txt = 'AL';   
                                    } else if(data.content[i].ins_type == 'wc'){
                                        data.content[i].ins_type_txt = 'WC';   
                                    } else if(data.content[i].ins_type == 'other'){
                                        data.content[i].ins_type_txt = 'Other';   
                                    }

                                    self.rows.push({
                                        ins_certi_item_id: data.content[i].id,
                                        policy_number:data.content[i].policy_number,
                                        policy_eff_date: data.content[i].policy_eff_date,
                                        policy_eff_date_error_msg: "",
                                        policy_exp_date: data.content[i].policy_exp_date,
                                        policy_exp_date_error_msg: "",
                                        ins_type:(data.content[i].ins_type != null && data.content[i].ins_type != "")?{
                                           value: data.content[i].ins_type,
                                           text: data.content[i].ins_type_txt
                                        }:"",
                                        other_ins_type:data.content[i].other_ins_type,
                                        ins_type_error_msg:"",
                                    })
                                }
                            }else{
                                self.rows.push({
                                    ins_certi_item_id:0,
                                    policy_eff_date:"", 
                                    policy_eff_date_error_msg:"",
                                    policy_exp_date:"", 
                                    policy_exp_date_error_msg:"",
                                    ins_type:"",
                                    other_ins_type:"",
                                    ins_type_error_msg:"",
                                    policy_number:""
                                });
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-insurance-certificate-items');
                    }
                });
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
            afterComplete(file,response){
                var self = this;

            },

            storeDocument(file,response){

                var self = this;
                $("#CreateInsCertiBtn").attr("disabled", false);

                var uploadResponse = response;
                //push doc path in files array
                var uploadFile = 1;

                if (self.files.length == 5) {
                    self.docerrors = "Maximum 5 files are allowed.";
                    uploadFile = 0;
                }

                if (uploadFile == 1) {
                    //push doc path in files array
                    self.files.push(uploadResponse.content);
                }

            },
            dropzoneUploadProgress(file, totalBytes, totalBytesSent){

                $("#CreateInsCertiBtn").attr("disabled", true);
            },
            removeAllFiles() {
                var self = this;
                self.$refs.dropzone.removeAllFiles();
            },
            removedSelectedFile(file, xhr, error) {
                var self = this;

                var orderId = "";
                var fileName = JSON.parse(file.xhr.response).content;

                var fileArr = fileName.split("/");

                self.removeFileFromServer(fileArr[1],orderId,"temp");

                for(var i = 0;i<self.files.length;i++){
                    if ( self.files[i].includes(fileName)) {
                        self.files.splice(i,1);
                    }
                }

            },
            removeServerFile(fileName,key) {

                var self = this;
                var orderId = "";
                var path = window.location.pathname;
                var segments = path.split("/");
                if ( segments[3] != undefined ) {
                    orderId = segments[3];
                }

                if (confirm('Are you sure that you want to remove file? ')) {

                    self.removeFileFromServer(fileName,orderId,"server");
                    self.dropZonePreviewFiles.splice(key,1);

                    //remove file from files array
                    for ( var i = 0;i<self.files.length;i++ ) {
                        if ( self.files[i].includes(fileName)) {
                            self.files.splice(i,1);
                        }
                    }
                }

            },
            removeFileFromServer(file, orderId,flag){

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/insurance-certificate/remove-doc",
                    type: "POST",
                    data: {
                        filePath : file,
                        id: orderId,
                        flag:flag
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'remove-insurance-certificate-doc');
                    }
                });

            },
            manuallyAddFile(file) {
                var self = this;
                if (self.files.length == 5) {
                    self.docerrors = "Maximum 5 files are allowed.";
                    return;
                }
            },
            getFilePathFromUrl(value) {

                var path = "";
                var src = value.split('/');
                var file_name = src[src.length - 1];
                var orgPath = src[src.length - 2];
                path = orgPath + "/" + file_name;
                return path;

            },
            //load files in drop zone
            loadFilesPreview:function() {
                var self = this;
                if ( self.dropZonePreviewFiles.length > 0 ) {
                    for ( var i = 0;i<self.dropZonePreviewFiles.length;i++ ) {
                        var file = { size: self.dropZonePreviewFiles[i].size, name: self.dropZonePreviewFiles[i].file_name, type: self.dropZonePreviewFiles[i].file_type};
                        var url = self.dropZonePreviewFiles[i].url;
                        //get file path from url
                        self.files.push(self.getFilePathFromUrl(self.dropZonePreviewFiles[i].url));
                    }
                }
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/InsuranceCertificateCreate.vue